// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__Pz03K","header":"styles_header__zWCSZ","columnsContainer":"styles_columnsContainer__boMmh","formContainer":"styles_formContainer__Xj_I2"};